import BaseModel from './BaseModel'
import { DefaultRate } from './DefaultRate'
import Event from './Event'
import { SpotRate } from './SpotRate'

export default class ParentSpotRate extends BaseModel {

  static entity = 'parent_spot_rates'
  static primaryKey = 'ID'

  declare ID: number
  declare defaultRateID: number
  declare eventID: number | null
  declare startDate: string
  declare endDate: string
  declare defaultRate: DefaultRate
  declare event: Event
  declare spotRates: SpotRate[]

  static fields() {

    return {

      // fields
      ID: this.attr(null),
      defaultRateID: this.number(null),
      eventID: this.number(null).nullable(),
      startDate: this.string(null),
      endDate: this.string(null),

      // relationships
      defaultRate: this.belongsTo(DefaultRate, 'default_rate_id'),
      event: this.belongsTo(Event, 'event_id'),
      spotRates: this.hasMany(SpotRate, 'parent_spot_rate_id'),

    }

  }

}
